let fullText; // variable to hold the full text
let shortText; // variable to hold the short version of the text
// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {

// how many characters to include in the shortened version
const shortTextLength = 200;
// read the full text and store it in the fullText variable
fullText = $w("#text10").text;
// grab the number of characters defined in shortTextLength and store them in the shortText variable
shortText = fullText.substr(0, shortTextLength) + "...";
// set the contents of the text element to be the short text
$w("#text10").text = shortText;	//TODO: write your page related code here...

});

export function button6_click(event) {
	// check the contents of the text element 
if ($w("#text10").text === shortText) {
  // if currently displaying short text, display the full text
  $w("#text10").text = fullText;
  $w("#button6").label = "Show less";    
} else {
  // if currently displaying full text, display the short text
  $w("#text10").text = shortText;
  $w("#button6").label = "Show more";
}//Add your code for this event here: 
}